<template>
	<div class="c-app" :class="{
		'c-dark-theme': $store.state.darkMode,
		// 'overflow-hidden': hideScroll,
	}">
		<TheSidebar />
		<TheAside />
		<CWrapper>
			<TheHeader />
			<div class="c-body">
				<main class="c-main" :class="$route.path.includes('spend-dashboard')
					|| $route.path.includes('opportunity-identification')
					|| $route.path.includes('summary-dashboard')
					|| $route.path.includes('opportunity-dashboard')
					|| $route.path.includes('opportunity-list')
					|| $route.path.includes('opportunity-categories')
					|| $route.path.includes('achievement-dashboard')
					|| $route.path.includes('supply-spend')
					|| $route.path.includes('service-spend') ? 'custom-main' : ''" :style="backgroundStyles">
					<CContainer fluid :class="$route.path.includes('spend-dashboard')
						|| $route.path.includes('opportunity-identification')
						|| $route.path.includes('summary-dashboard')
						|| $route.path.includes('opportunity-dashboard')
						|| $route.path.includes('opportunity-list')
						|| $route.path.includes('opportunity-categories')
						|| $route.path.includes('achievement-dashboard')
						|| $route.path.includes('supply-spend')
						|| $route.path.includes('service-spend') ? 'custom-fluid' : ''">
						<transition name="fade">
							<router-view :key="$route.path"></router-view>
						</transition>
					</CContainer>
				</main>
			</div>
		</CWrapper>
	</div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheAside from "./TheAside";
import { storeData } from "../store";
import gql from "graphql-tag";

const GET_CLIENTS_LIST = gql`
	query MyQuery {
		spendmd_db_clients(
			where: { name: { _neq: "SpendMD" } }
			order_by: { name: asc }
		) {
			id
			name
		}
	}
`;


const GET_CLIENTS_LIST_OF_GROUP_ADMIN = gql`
	query ($input_user: json) {
		spendmd_db_client_list(
			args: { input_user: $input_user },
			where: { name: { _neq: "SpendMD" }}
			) {
				id
				name
			}
		}
`;

export default {
	name: "TheContainer",
	data() {
		return {
			data: [],
		};
	},
	components: {
		TheSidebar,
		TheHeader,
		TheAside,
	},

	computed: {
		// hideScroll() {
		// 	if (this.$route.path.includes("spend-dashboard")) return true;
		// },
	},

	beforeCreate: function () {
		if (!this.$session.exists()) {
			this.$router.push("/");
		}
	},

	beforeMount() {
		window.addEventListener("beforeunload", (event) => {
			// event.preventDefault();
			localStorage.setItem("store", JSON.stringify(storeData));
			return false;
		});
	},

	async mounted() {
		storeData.clientList = [];
		storeData.clientList.push({
			label: "All",
			value: "All",
		});

		const role = storeData.currentUserDetails.role.name;
		let result = [];
		if (role === "group_admin") {
			const userId = storeData.currentUserDetails.id;
			const res = await this.$apollo
				.mutate({
					mutation: GET_CLIENTS_LIST_OF_GROUP_ADMIN,
					variables: {
						input_user: [userId],
					},
				});
			result = res.data.spendmd_db_client_list;
		}
		else {
			const res = await this.$apollo.mutate({
				mutation: GET_CLIENTS_LIST,
			});
			result = res.data.spendmd_db_clients;
		}

		for (const el of result) {
			storeData.clientList.push({
				label: el.name,
				value: el.id,
			});
		}
	},
	computed: {
		backgroundStyles() {
			return {
				"background-image": `linear-gradient(to bottom left, white, ${this.$themeColors.green["100"]})`
			};
		}
	}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.custom-fluid {
	padding-left: 0 !important;
	padding-right: 0px !important;
}

.custom-main {
	padding-top: 0 !important;
}
</style>
